//product page share button
$(".js-product-share").click(function (e) {
  e.preventDefault();
  if (navigator.share) {
    let title = $(this).data("title");
    let text = $(this).data("text");
    let url = $(this).data("url");
    navigator
      .share({
        title: title,
        text: text,
        url: url,
      })
      .then(() => console.log("Successful share"))
      .catch((error) => console.log("Error sharing", error));
  } else {
    console.log("Share not supported on this browser, do it the old way.");
  }
});

//tooltip container click prevent propagation
$(document).on("click", ".js-tooltip-container", function (e) {
  e.preventDefault();
  e.stopPropagation();
});


//see more handler
$(".js-see-more").click(function (e) {
  e.preventDefault();
  $(this).hide();
  $(this).siblings(".see-more-content").slideDown(400);

  if ($(this).hasClass("js-see-more-references")) {
    $(this)
      .parents(".product-template-section-content")
      .addClass("is-expanded");
  }
});


$(".mobile-tab h3").click(function (e) {
  var $parent = $(this).parents(".mobile-tab");
  if ($parent.attr("id") == "mobile-tab-description") {
    var ingredient_list = $parent.find(".ingredients-list");
    if (!ingredient_list.hasClass("init")) {
      ingredient_list.slick("refresh");
    }
    ingredient_list.addClass("init");
  }
  $parent.toggleClass("open");
  $parent.find(".mobile-tab-content").slideToggle(400, function () {
    //trigger only if scroll to fixed
    if ($(window).width() > 768) {
      $(".product-photo-section").trigger("resize");
      $(window).resize();
    }
  });
});




/* CHECK FIRST IF PHOTO PART IS LARGER THAN INFORMATION. IF NOT DONT MAKE FIXED */
var $product_form_inner_wrapper = $(".form__inner__wrapper");

if (
  $(".product-photo-wrapper").height() >
    $product_form_inner_wrapper.outerHeight(true) + 300 &&
  $(window).width() > 768
) {
  let $product_form_wrapper = $(".form__wrapper");

  $(document).on("product-form-resize", function () {
    if (
      $(".product-photo-wrapper").height() <
      $product_form_inner_wrapper.outerHeight(true) + 200
    ) {
      $product_form_wrapper.trigger("detach.ScrollToFixed");
    } else {
      $product_form_wrapper.trigger("resize");
    }
  });
}

//variant dropdown
$(document).on("click", ".variant-dropdown-container", function () {
  $(".variant-dropdown-na").toggle();
  $(this).toggleClass("custom-close");
});

$(document).on("click", ".variant-dropdown-na", function () {
  var text = $(this).find(".variant-dropdown-text").text();
  var promo_text = $(this).find(".variant-dropdown-promo-text").clone();
  var dropdown_active = $(".variant-dropdown-active");
  var value = $(this).data("option");
  var selectId = $(this).closest(".variant-dropdown-container").data("target");
  dropdown_active.find(".variant-dropdown-promo-text").remove();
  dropdown_active.append(promo_text);
  dropdown_active.data("value", value);
  $(".variant-dropdown-text-active").text(text);

  $("#" + selectId).val(value);
  $("#" + selectId).trigger("change");

  //dispatch change event for recharge
  let event = new Event("change", { bubbles: true });
  let select = document.getElementById(selectId);
  select.dispatchEvent(event);
});


function SwatchChooseFirst() {
  if ($(".variant-dropdown-na").length != 0) {
    var $first = $(".variant-dropdown-na").first();
    //console.log('first:' , $first);
    var first_option = $first.data("option");
    var selectId = $first.closest(".variant-dropdown-container").data("target");
    var dropdown_active = $(".variant-dropdown-active");
    var promo_text = $first
      .find(".variant-dropdown-promo-text")
      .clone()
      .text("Save More");
    var text = $first.find(".variant-dropdown-text").text();
    console.log(promo_text);
    dropdown_active.find(".variant-dropdown-promo-text").remove();
    dropdown_active.append(promo_text);
    dropdown_active.data("value", first_option);
    $(".variant-dropdown-text-active").text(text);
    $("#" + selectId).val(first_option);
    $("#" + selectId).trigger("change");

    //dispatch change event for recharge
    let event = new Event("change", { bubbles: true });
    let select = document.getElementById(selectId);
    select.dispatchEvent(event);
  }
}

$(document).on("click", ".custom-dropdown-container", function () {
  $(".custom-dropdown-na").toggle();
  $(this).toggleClass("custom-close");
});

$(document).on("click", ".custom-dropdown-na", function () {
  var text = $(this).find(".custom-dropdown-text").text();
  var dropdown_active = $(".custom-dropdown-active");
  var sellingId = $(this).data("selling-id");
  let sellingPlanInput = $("#rc-custom-widget-selling-plan");
  sellingPlanInput.val(sellingId);
  console.log(sellingPlanInput.val());
  dropdown_active.data("selling-id", sellingId);

  $(".dropdown-text-active").text(text);
});

$(".supplement-facts-trigger, .supplement-facts-zoom").click(function (e) {});

$(".product__thumbs--square #zoom").click(function (e) {
  e.preventDefault();
  console.log("zoom");
  var src = $(".product__photo.slick-active").find("[data-zoom]").data("src");
  var height = 0;
  var width = 0;
  let $imgContainer = $(".product-mobile-zoom img");
  if($imgContainer.length > 0){
    $imgContainer.attr("src", src);
  }else{
    $imgContainer = $(`<img src="${src}" alt="Zoomed in image" />`)
    $('.product-mobile-zoom').append($imgContainer);
  }
  $(".product-mobile-zoom img").attr("src", src);

  var $draggable = $(".product-mobile-zoom img").draggabilly();
  $(".product-mobile-zoom img").css({});
  $(".product-mobile-zoom").removeClass("close");
});

$(".product-mobile-zoom-close").click(function () {
  $(".product-mobile-zoom").addClass("close");
  $(".product-mobile-zoom img").draggabilly("destroy");
});

$(".reference-link").click(function (e) {
  e.preventDefault();
  var referenceTab = $('[data-tab="references"]');
  var scrollTop = referenceTab.offset().top - 200;
  console.log(scrollTop);
  $(window).scrollTop(scrollTop);
  referenceTab.trigger("click");
});


$(".description-accordion-heading").click(function (e) {
  var $parent_el = $(this).parents(".product-description-accordion");
  if ($parent_el.hasClass("open")) {
    $parent_el.removeClass("open");
    $(".description-accordion-child").slideUp(400);
  } else {
    $parent_el.addClass("open");
    $(".description-accordion-child").slideDown(400);
  }
});

function scrollProductModules(){
      
  let $container = $('.template-product-wrapper');
  let $photoSection = $('.product-photo-section');
  let $photoContainer = $photoSection.find('.product-photo-flex-wrapper');
  let $formSection = $('#product-details-wrapper .form__wrapper')
  let tallLayout = $container.data('tall-layout');
  let fixedPhotoSection = $container.data('sticky-photo');
  let photoHeight = $photoSection.outerHeight();
  let detailsHeight = $formSection.outerHeight();

  if(tallLayout){
  
    if(photoHeight > detailsHeight){
      $formSection.scrollToFixed({
        marginTop: 80,
        limit: function(){
          let photoHeight = $('.product-photo-section').outerHeight();
          let detailsHeight = $('#product-details-wrapper .form__wrapper').outerHeight();
          
          let limit = photoHeight - detailsHeight ;
          let $fullScreenVideo = $('.product-video-header-fullscreen-wrapper');
          if($fullScreenVideo.length > 0){
            limit = limit + $fullScreenVideo.outerHeight();
          }

          if(limit <= 0){
            limit = 1;
          }


          return limit;
        },
        minWidth: 768,
        zIndex: 1,
        removeOffsets: false
      })
    }

  }else{

    if(!fixedPhotoSection) return;

    if($container.hasClass('custom_template_6')){
      $photoContainer.scrollToFixed({
        marginTop: 80,
        limit: function(){
          let photoSectionHeight = $('.product-photo-flex-wrapper').outerHeight();
          let limit = $("#product-details-wrapper").outerHeight() - photoSectionHeight + 20; //+ 20 for the margins
          let $fullScreenVideo = $('.product-video-header-fullscreen-wrapper');
          if($fullScreenVideo.length > 0){
            limit = limit + $fullScreenVideo.outerHeight();
          }else{
            limit = limit + $('.product-container #breadcrumbs').outerHeight();
          }

          if(limit <= 0){
            limit = 1;
          }


          return limit;
        },
        minWidth: 768,
        zIndex: 1,
        removeOffsets: false
      })

    }else{
      $photoSection.scrollToFixed({
        marginTop: 80,
        limit: function(){
          let photoSectionHeight = $('.product-photo-section-container').outerHeight();
          let limit = $("#product-details-wrapper").outerHeight() - photoSectionHeight;
          let $fullScreenVideo = $('.product-video-header-fullscreen-wrapper');
          if($fullScreenVideo.length > 0){
            limit = limit + $fullScreenVideo.outerHeight();
          }

          if(limit <= 0){
            limit = 1;
          }


          return limit;
        },
        minWidth: 768,
        zIndex: 1,
        removeOffsets: false
      })
    }

  }

}

//trigger jarallax video on product page
$('.product-parallax-video-container').each(function(){
  console.log('jarallax-video')
  $(this).jarallax({
    videoSrc: $(this).data('video-src'),
    imgSrc: $(this).data('img-src'),
    speed: $(this).data('speed') || 0.5
  })
})



//product info modal script
$('.js-product-info-modal-open').click(function(e){
  e.preventDefault();
  let tab = $(this).data('tab');
  let $modal = $('.product-details-modal-wrapper');
  if($modal.length == 0) return;

  let $activeTab = $modal.find(`[data-tab="${tab}"]`);
  $modal.find('.product-modal-content').removeClass('active');
  $activeTab.addClass('active');
  
  $('html').addClass('modal--open');
  $modal.addClass('open');

  if(tab == "chat"){
    //scroll to bottom after opening
    document.querySelector('codeage-ai-chat-form').scrollBottom();
  }

  setTimeout(function(){
    $modal.addClass('bg-active');
    $modal.find('.product-details-modal-container').addClass('active');

    //click outside of product details modal
    $(document).on("click.product-details-modal", function (event) {
      let $modal = $('.product-details-modal-wrapper');
      if ($modal.hasClass("open") && !$(event.target).closest(".product-details-modal-container").length) {
        closeProductDetailsModal();
      }
    });
  }, 100)
})

$('.js-product-details-modal-close').click(function(e){
  e.preventDefault();
  closeProductDetailsModal();
})

function closeProductDetailsModal(){
  let $modal = $('.product-details-modal-wrapper');
  $modal.removeClass('bg-active');
  $modal.find('.product-details-modal-container').removeClass('active');
  setTimeout(function(){
    $modal.removeClass('open');
    $('html').removeClass('modal--open');
    $(document).off('.product-details-modal')
  }, 300)
}



$('.js-product-buy-now-links-toggle').click(function (e) {
  e.preventDefault();

  let parent = $(this).parent('.product-buy-now-links-container');
  let wrapper = $(this).parents('.product-buy-now-wrapper');
  if (!parent.hasClass('open')) {
    window.addEventListener('click', handleClickOutsideBuyNowLinks);
  } else {
    window.removeEventListener('click', handleClickOutsideBuyNowLinks);
  }

  parent.toggleClass('open');
    wrapper.toggleClass('menu-open');
});

$('.js-product-buy-now-link--anchor').click(function(e){
  e.stopPropagation();
  closeBuyNowLinks();

  if($(this).hasClass('js-product-buy-now-link--mobile-tab')){
    e.preventDefault();
    let target = $(this).data('target');
    let parent_selector = `.mobile-product-tabs ${target}`;
    let tab_trigger = $(parent_selector).find('h3');
    console.log('tab: ', tab_trigger)
      $('html, body').animate({
          scrollTop: $(parent_selector).offset().top - 200
      }, 400, function(){
        if(!$(parent_selector).hasClass('open')){
          $(tab_trigger).trigger('click');
        }
      });
  }
})

function handleClickOutsideBuyNowLinks(e) {
  if (
    !$(e.target).is('.product-buy-now-links-container *') &&
    $('.product-buy-now-links-container').hasClass('open')
  ) {
    closeBuyNowLinks();
  }
}

function closeBuyNowLinks() {
  $('.product-buy-now-links-container').removeClass('open');
  $('.product-buy-now-wrapper').removeClass('menu-open');
}

$('.js-header-icon-listen').click(function(e){
  e.preventDefault();
  let target = $(this).data('target');

  let audioPlayer = document.querySelector(target);

  audioPlayer.classList.add("audio-player-open");
  audioPlayer.play();
  $(this).addClass('audio-player-open');
})


function init(){
    scrollProductModules()
}



init();

/* THEME PRODUCT */
theme.Product = (function () {
  var selectors = {
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    formWrapper: "[data-form-wrapper]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productSlideshow: "[data-product-slideshow]",
    productPhotoWrapper: "[data-product-photo-wrapper]",
    productImage: "[data-product-image]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-thumbs]",
    singleOptionSelector: "[data-single-option-selector]",
    zoomWrapper: "[data-zoom-wrapper]",
    drawerWrapper: ".drawer-wrapper",
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    console.log("initadd 2");
    this.container = container;
    this.$container = $(container);
    this.id = this.$container.attr("data-section-id");
    this.tallLayout = this.$container.data("tall-layout");

    this.drawer = theme.Drawer;

    this.init();
    this.tabs();
    this.tabsSpaceCheck();


    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.initZoom();
    this.accordion();
    this.recent();
    this.initAdd();
    //this.initSlider();

    this.productVideo();


    var currentScope = this;
    $(window)
      .resize(function () {
        currentScope.tabsSpaceCheck();
      })
      .resize();

    this.productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.settings = {};
    this.namespace = ".product";
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on(
      "variantChange" + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      "variantPriceChange" + this.namespace,
      this.updateProductPrices.bind(this)
    );
    this.$container.on(
      "variantImageChange" + this.namespace,
      this.updateProductImage.bind(this)
    );

    var enableSwatches = $(container).find(".product-form").data("swatches");
    var product = this.productSingleObject;

    if (enableSwatches) {
      theme.ColorSwatches.bind();
    }

    var showReviews = this.$container.data("reviews");
    var reviewsAppInstalled = typeof window.SPR == "function";

    if (showReviews && reviewsAppInstalled) {
      window.SPR.initDomEls();
      window.SPR.loadBadges();
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    init: function () {
      theme.mediaInstances[this.id] = new theme.Media(this.container);
      theme.mediaInstances[this.id].init();
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;
      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass("hide");

        // BEGIN SWATCHES
        var form = $(selectors.singleOptionSelector, this.$container).closest(
          "form"
        );

        for (var i = 0, length = variant.options.length; i < length; i++) {
          var radioButton = form.find(
            '.swatch[data-option-index="' +
              i +
              '"] :radio[value="' +
              escape(variant.options[i]) +
              '"]'
          );
          if (radioButton.length) {
            radioButton.get(0).checked = true;
          }
        }
        // END SWATCHES
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.formWrapper, this.$container)
          .removeClass("variant--soldout")
          .addClass("variant--unavailabe");
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop("disabled", false);
        $(selectors.addToCartText, this.$container).html(
          theme.strings.addToCart
        );
        $(selectors.formWrapper, this.$container).removeClass(
          "variant--soldout variant--unavailabe"
        );
      } else {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.formWrapper, this.$container)
          .removeClass("variant--unavailabe")
          .addClass("variant--soldout");
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $productPrice = $(selectors.productPrice, this.$container);
      var $productBuyNowPrice = $(
        ".product-buy-now-price [data-product-price]"
      );
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $("#_compareprice").val(variant.compare_at_price);

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      $productBuyNowPrice.html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass("hide");
        $productPrice.addClass("product__price--sale");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
        $productPrice.removeClass("product__price--sale");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      if (variant) {
        // Update variant image, if one is set
        if (variant.featured_media) {
          var $newImg = $(
            selectors.productImage +
              '[data-image-id="' +
              variant.featured_media.id +
              '"]',
            this.$container
          );
          var newPosition = $newImg
            .parents("[data-product-single-media-wrapper]")
            .attr("data-slick-index");

          // If we have a mobile breakpoint or the tall layout is disabled,
          // just switch the slideshow.
          if (theme.variables.bpSmall || !this.tallLayout) {
            // Slider not loaded
            if (newPosition === undefined) {
            } else {
              $(selectors.productSlideshow, this.$container).slick(
                "slickGoTo",
                newPosition
              );
            }
          }
          // We know its a tall layout, if it's sticky
          // scroll to the images
          else {
            imageIndex = $newImg.closest(".slick-slide").index();
            // Scroll to/reorder image unless it's the first photo on load
            if (imageIndex !== 0) {
              // Scroll to variant image
              $("html, body").animate(
                {
                  scrollTop: $newImg.offset().top,
                },
                250
              );
            }
          }
        }
      }
    },
    createSlider: function () {
      console.log("createSlider");
      $(selectors.productSlideshow, this.$container).slick({
        adaptiveHeight: true,
        dots: true,
        arrows: arrows,
        fade: true,
        swipe: true,
        touchThreshold: 20,
        appendDots: $(selectors.productThumbs, this.$container),
        customPaging: function (slider, i) {
          var thumb = $(slider.$slides[i]).data("thumb");
          var thumbAlt = $(slider.$slides[i])
            .find("[data-product-image]")
            .attr("alt");
          console.log("custom paging");
          return '<img alt="' + thumbAlt + '" src="' + thumb + '">';
        },
      });
    },
    initSlider: function () {
      /*
      var self = this;
      if (this.tallLayout) {
        enquire.register(theme.variables.mediaQuerySmall, {
          match: function () {
            self.createSlider();
          },
          unmatch: function () {
            $(selectors.productSlideshow, this.$container).slick("unslick");
          },
        });
      } else {
        self.createSlider();
      }
      */
    },
    productVideo: function () {

    },
    initAdd: function () {
      theme.quantitySelectors();
      console.log("het ATCasdasdas");
      $(document).on("click", ".add-js:not(.is-locked)", function (e) {
        e.preventDefault();
        console.log("het ATC");
        var quantity = $(this).closest("form").find(".quantity__input").val(),
          productID = $(this).closest(".product__submit").data("product-id"),
          collectionID = $(this).data("collection"),
          form = $(this).closest("form"),
          form_array = form.serializeArray();
        if (form.find('[type="file"]').length) {
          return;
        }
        var form_data = {};
        $.map(form_array, function (val, i) {
          form_data[val.name] = val.value;
        });
        addItem(form_data, collectionID);
      });
      var addItem = function (data, collectionID) {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: data,
          success: function (product) {
            addToCartOkay(product, collectionID);
          },
          error: addToCartFail,
        });
      };

      var cartSlick = function ($cartCarousell) {
        $(".cart-popup-related").show();
        $(".cart-popup-related").css("visibility", "hidden");
        $cartCarousell.slick({
          dots: false,
          infinite: true,
          arrows: true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
          nextArrow:
            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 20 38"><path d="M15.932 18.649L.466 2.543A1.35 1.35 0 0 1 0 1.505c0-.41.155-.77.466-1.081A1.412 1.412 0 0 1 1.504 0c.41 0 .756.141 1.038.424l16.992 17.165c.31.283.466.636.466 1.06 0 .423-.155.777-.466 1.06L2.542 36.872a1.412 1.412 0 0 1-1.038.424c-.41 0-.755-.141-1.038-.424A1.373 1.373 0 0 1 0 35.813c0-.423.155-.776.466-1.059L15.932 18.65z" fill="#726D75" fill-rule="evenodd"/></svg>',
          prevArrow:
            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 20 38"><path d="M4.068 18.649l15.466 16.105c.31.283.466.629.466 1.039 0 .41-.155.77-.466 1.08a1.412 1.412 0 0 1-1.038.424c-.41 0-.756-.141-1.038-.424L.466 19.708A1.373 1.373 0 0 1 0 18.648c0-.423.155-.776.466-1.059L17.458.424A1.412 1.412 0 0 1 18.496 0c.41 0 .755.141 1.038.424.31.282.466.636.466 1.06 0 .423-.155.776-.466 1.059L4.068 18.649z" fill="#726D75" fill-rule="evenodd"/></svg>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ],
        });
        $(".cart-popup-related").css("visibility", "visible");
      };

      var checkDrawerItems = function (product) {
        var $drawer = $(selectors.drawerWrapper);
        var $drawerCartItems = $drawer.find(".cart-item");
        var itemFound = false;
        $drawerCartItems.each(function () {
          var id = $(this).data("id");
          var searchKey = product.key;
          console.log(searchKey);
          if (id == searchKey) {
            itemFound = id;
          }
        });

        return itemFound;
      };

      var addItemToDrawer = function (product) {
        var price = product.price;
        var title = product.product_title;
        var url = product.url;
        var image = product.image;
        var quantity = product.quantity;
        if (
          product["properties"] !== null &&
          product["properties"] !== undefined
        ) {
          if (
            product["properties"]["_ro_unformatted_price"] !== null &&
            product["properties"]["_ro_unformatted_price"] !== undefined
          ) {
            price = product["properties"]["_ro_unformatted_price"];
          }
        }
        var price = slate.Currency.formatMoney(price, theme.moneyFormat);
        var key = product.key;

        var cart_item =
          `<div class="cart-item" data-id="` +
          key +
          `">
          <div class="cart-item-image">
            <img src="` +
          image +
          `">
          </div>
          <div class="cart-item-content">
            <h6 class="cart-item-title">
              <a href="` +
          url +
          `">
                 ` +
          title +
          `
              </a>
            </h6>
            <div class="drawer-control-group">
              <div class="quantity-selector drawer-quantity-selector">
                <span data-operation="minus" class="drawer-qty-adjust quantity__minus">
					<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/></svg>
				</span>
				<input type="text" class="js-qty__num quantity__input" value="` +
          quantity +
          `" min="1" aria-label="quantity" pattern="[0-9]*" name="quantity">
                <span data-opeation="plus" class="drawer-qty-adjust quantity__plus">
					<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg>
				</span>
              </div>


			  <p><span class="cart-item-price money">` +
          price +
          `</span></p>
            </div>
			
            <a class="cart-item-remove-container">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 20 20"><path fill="#444" d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"/></svg>
            </a>
          </div>
        </div>`;

        $(".drawer-main .cart-item-wrapper").prepend($(cart_item));
      };

      var showDrawer = function () {
        $("#CartButton").trigger("click");
      };

      var addToCartOkay = function (product, collectionID) {
        theme.Drawer.addToCartOkay(product);

        var $cartCarousell = $(".cart-popup-related .product-grid");
        var currentCollectionID = $cartCarousell.data("collection");

        $(".cart-popup-related").css("visibility", "hidden");

        var addedQuantity = parseInt(
            $(".quantity__input", this.$container).val()
          ),
          prevCartQuantity = parseInt($("#CartButton .cart-count-js").text()),
          newTotal = addedQuantity + prevCartQuantity;
        $("#CartButton .cart-count-js")
          .text(newTotal)
          .show()
          .addClass("pulse-cart-icon");
        setTimeout(function () {
          $("#CartButton .cart-count-js").removeClass("pulse-cart-icon");
        }, 800);
        $("form .errors", this.$container).remove();
      };
      var addToCartFail = function (obj, status) {
        $("form .errors", this.$container).remove();
        $(".product__add__success").addClass("product__add__success--hide");
        $(
          "<div class='errors'>" +
            obj.responseJSON.message +
            ": " +
            obj.responseJSON.description +
            "</div>"
        ).appendTo("form", this.$container);
      };
    },
    initZoom: function () {
      if ($(window).width() > 768 && !this.tallLayout) {
        console.log("zoom func");
        $(selectors.zoomWrapper, this.$container).one("click", function () {
          var $this = $(this);
          $this.zoom({
            on: "click",
            touch: "false",
            callback: function () {
              $this.click();
            },
            onZoomIn: function () {
              $this.addClass("zoom--active");
            },
            onZoomOut: function () {
              $this.removeClass("zoom--active");
            },
          });
        });
      }
      /*
      //open fancy box if tall layout
      console.log('fancy zoom 2')
      if($(window).width() > 768 && this.tallLayout){
        console.log('fancy zoom')
        $(selectors.zoomWrapper, this.$container).one("click", function () {
          $.fancybox.open( $('.product-media-item', this.$container), {
            type: 'image'
          });
        });
      }
      */

      if(this.tallLayout){
        function toggleFancyBoxZoom(){
          const isDesktop = window.innerWidth >= 768;
          const $fancyboxItems = $('[data-fancybox="product-gallery"]');
      
          if (isDesktop) {
            // Ensure Fancybox is bound (in case user resized back to desktop)
            console.log('enable fancy');
            //$fancyboxItems.data('fancybox', 'product-gallery');
            $fancyboxItems.fancybox({
              loop: true,
              buttons: ['zoom', 'close']
            });
          } else {
            // Unbind Fancybox events and prevent opening
            console.log('disaable fancy');
            

            $fancyboxItems.each(function(){
              $(this).off('click.fb-start', '[data-fancybox]');
              $(this).removeData('fancybox');
            })

            // Always clean up old Fancybox state first
            $.fancybox.destroy();
          
            // Always remove the delegated click handler Fancybox uses
            $(document).off('click.fb-start', '[data-fancybox]');
            /*

            
            $fancyboxItems.each(function(){
              
              console.log($(this),'disaable fanc1');
              $(this).off('click.fb-start');
              $(this).removeData('fancybox');
            })
            $fancyboxItems.off('click.fb-start').removeData('fancybox');
            $(document).off('click.fb-start', '[data-product-single-media-wrapper]');
            */
          }
        }


        $(window).on('resize', debounce(toggleFancyBoxZoom, 500));
        $(document).ready(toggleFancyBoxZoom);
      }
    },
    tabs: function () {
      $(".tab-content-0", this.$container).addClass("current");
      $(".tab-link-0", this.$container).addClass("current");
      $("ul.tabs > li", this.$container).click(function () {
        var tab_id = $(this).attr("data-tab");
        $("ul.tabs > li", this.$container).removeClass("current");
        $(".tab-content", this.$container).removeClass("current");
        $(this).addClass("current");
        $(".tab-content-" + tab_id, this.$container).addClass("current");
      });
    },
    accordion: function () {
      // mobile accordion for tabs content
      $(".accordion-toggle", this.$container).click(function () {
        if ($(this).next("div").is(":visible")) {
          $(this).next("div").slideUp("fast");
        } else {
          $(this).next("div").slideDown("fast");
        }
        $(this).find(".accordion__icon").toggleClass("rotate-90");
      });
    },
    tabsSpaceCheck: function () {
      var tabsWidth = $(".tabs", this.$container).width();
      var tabsWrapper = $(".productTabsWrapper", this.$container).width() - 31;
      if (tabsWidth >= tabsWrapper) {
        $(".product-tabs", this.$container).css({
          position: "absolute",
          left: "-9999px",
          display: "table",
        });
        $(".product-accordion", this.$container).show();
      } else {
        $(".product-tabs", this.$container).removeAttr("style");
        $(".product-accordion", this.$container).hide();
      }
    },
    recent: function () {
      Shopify.Products.recordRecentlyViewed();

      Shopify.Products.showRecentlyViewed({
        howManyToShow: 4,
        onComplete: function () {
          var recentProductsCount = $(
            "#recently-viewed-products .product-item"
          ).length;
          if (recentProductsCount) {
            $("#RecentlyViewed").fadeIn(100);
          }
        },
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },

    productUnlock: function () {
      var $atc_text = $(
        `<span data-add-to-cart-text>${theme.strings.addToCart}</span>`
      );
      var $atc_button = $(".js-lock-cta");
      var $product_page_container = $(".product-custom-wrapper");
      $atc_button.removeClass("is-locked");
      $atc_button.removeClass("product-lock-cta-button");
      $atc_button.html($atc_text);
      $atc_button.removeClass("js-lock-cta");
      $product_page_container.removeClass("product-page-is-locked");

      $("#product-main-widget-wrapper").removeClass("focus");
    },
  });

  return Product;
})();


/**
 * Media
 * ------------------------------------------------------------------------------
 * This object powers both the product templates and the quick-view
 *
 * @namespace Media
 */
theme.mediaInstances = {};
theme.Media = (function () {
  var selectors = {
    productSlideshow: "[data-product-slideshow]",
    productThumbs: "[data-product-thumbs]",
    videoPlayer: "[data-video]",
    modelViewer: "[data-model]",
    zoomWrapper: "[data-zoom-wrapper]",
  };

  var thumbIcons = {
    model:
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path d="M1 25h24V1H1z"/><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
    video:
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
  };

  function Media(container) {
    this.container = container;
    this.$container = $(container);
    this.id =
      this.$container.attr("data-section-id") || this.$container.attr("id");
    this.tallLayout = this.$container.data("tall-layout");
    this.players = {};
  }

  Media.prototype = $.extend({}, Media.prototype, {
    init: function () {
      this.detectVideo();
      this.detect3d();
      this.launch3d();
      this.initZoom();
      this.initSlider();
    },
    createSlider: function () {
      var instance = this;
      console.log("media3", this.$container);
      $(selectors.productSlideshow, this.$container)
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          var $currentMedia = $(slick.$slides[currentSlide]),
            $newMedia = $(slick.$slides[nextSlide]);
          $currentMedia.trigger("mediaHidden");
          $newMedia.removeClass("media--hidden");
        })
        .on("afterChange", function (event, slick, currentSlide) {
          var $currentMedia = $(slick.$slides[currentSlide]),
            $otherMedia = $currentMedia.siblings(),
            mediaType = $(slick.$slides[currentSlide]).attr("data-type"),
            isFocusEnabled = $("body").hasClass("focus-enabled");

          console.log("after");

          // disable swipe on 3d models and videos
          if (
            mediaType === "model" ||
            mediaType === "video" ||
            mediaType === "external_video"
          ) {
            // fisrt boolean sets value, second option false to prevent refresh
            //slick.slickSetOption('swipe', false, false);
            $(".product__thumbs--square #zoom").hide();
          } else {
            slick.slickSetOption("swipe", true, false);
            $(".product__thumbs--square #zoom").show();
          }
          if (isFocusEnabled) $currentMedia.focus();

          $otherMedia.addClass("media--hidden");
          $currentMedia.trigger("mediaVisible");
        });

      // if the first element is a model or video, disable swipe
      $(selectors.productSlideshow, this.$container).on(
        "init",
        function (event, slick) {
          if (slick.$slides !== null) {
            var firstType = $(slick.$slides[0]).attr("data-type");
          } else {
            var firstType = "image";
          }
          var $productThumbImages =
            instance.$container.find("[data-thumbnail]");

          $(slick).attr("tabindex", "-1");
          $(slick.$slides).attr("tabindex", "-1");

          $productThumbImages
            .on("click", function (e) {
              e.preventDefault();
            })
            .on("keyup", function (e) {
              // On keypress Enter move the focus to the first focusable element in the related slide
              if (e.keyCode === 13) {
                var mediaId = $(this).data("media-id");
                $(slick.$slides)
                  .filter('[data-media-id="' + mediaId + '"]')
                  .find(
                    'model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])'
                  )
                  .eq(0)
                  .focus()
                  .select();
              }
            });

          if (
            firstType === "model" ||
            firstType === "video" ||
            firstType === "external_video"
          ) {
            slick.slickSetOption("swipe", false, false);
            slick.slickSetOption("accessibility", false, false);
          }
        }
      );

      try {
        let arrows =
          $(selectors.productSlideshow, this.$container).data("arrows") ||
          false;

        console.log("slideshow arr:", arrows);
        $(selectors.productSlideshow, this.$container).slick({
          accessibility: false,
          focusOnSelect: false,
          adaptiveHeight: true,
          dots: true,
          arrows: arrows,
          fade: true,
          swipe: true,
          infinite: false,
          prevArrow: `<button aria-label="Previous" title="Previous" type="button" class="slick-prev">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"/></svg>
          </button>`,
          nextArrow: `<button aria-label="Next" title="Next" type="button" class="slick-next">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"/></svg>
          </button>`,
          // eslint-disable-next-line

          appendDots: $(selectors.productThumbs, this.$container),
          customPaging: function (slider, i) {
            var thumb = $(slider.$slides[i]).data("thumb");
            var thumbAlt = $(slider.$slides[i])
              .find("[data-product-image]")
              .attr("alt");
            return (
              '<img alt="' +
              thumbAlt +
              '" class="product-slider-dot-thumnail" loading="lazy" src="' +
              thumb +
              '"><button title="Slider Dot" type="button" class="product-slider-dot">' +
              (i + 1) +
              "</button><hr class='product-thumbnail-hr'/>"
            );
          },
          responsive: [
            {
              breakpoint: 768,
              settings: {
                fade: false,
                swipe: true,
                arrows: false,
                touchMove: true,
                swipeToSlide: true,
                touchThreshold: 20,
                speed: 100,
                infinite: false,
              },
            },
          ],
        });
      } catch (e) {
        console.log(e);
      }
    },

    initSlider: function () {
      var instance = this;
      console.log("test");
    
      if (this.tallLayout) {
        enquire.register(theme.variables.mediaQuerySmall, {
          match: function () {
            console.log("create2");
            instance.createSlider();
          },
          unmatch: function () {

            setTimeout(function(){
              console.log("unmatch fired");
              var $slideshow = $(selectors.productSlideshow, instance.$container);
              if ($slideshow.length && $slideshow.hasClass("slick-initialized")) {
                console.log("unslicking...");
                //console.log($slideshow.slick('getSlick'));
                //$slideshow.slick('getSlick').destroy();
                $slideshow.slick("unslick");
              } else {
                console.log("slider not initialized");
              }
            }, 400)
            
          }
        });
      } else {
        console.log("create1");
        this.createSlider();
      }
    },
    detect3d: function () {
      var $modelViewerElements = $(selectors.modelViewer, this.$container);
      if ($modelViewerElements.length) {
        theme.ProductModel.init($modelViewerElements, this.id);
      }
    },
    launch3d: function () {
      var instance = this;
      $(document).on("shopify_xr_launch", function () {
        var $currentMedia = $(
          instance.selectors.modelViewer + ":not(.media--hidden)",
          instance.$container
        );

        $currentMedia.trigger("xrLaunch");
      });
    },
    detectVideo: function () {
      var playerElements = this.container.querySelectorAll(
        selectors.videoPlayer
      );
      var hasYouTube = false;
      var hasNative = false;

      for (var i = 0; i < playerElements.length; i++) {
        var newPlayerID = playerElements[i].getAttribute("id");
        var newPlayerType = playerElements[i].getAttribute("data-type");
        var newPlayerMediaId = playerElements[i].getAttribute("data-media-id");

        this.players[newPlayerID] = {};
        this.players[newPlayerID].id = newPlayerID;
        this.players[newPlayerID].type = newPlayerType;
        this.players[newPlayerID].mediaId = newPlayerMediaId;
        this.players[newPlayerID].container = playerElements[i];
        this.players[newPlayerID].element =
          playerElements[i].querySelector("iframe, video");

        if (!this.players[newPlayerID].element) return;

        if (newPlayerType === "external_video") {
          var youtubeID = playerElements[i].getAttribute("data-youtube-id");
          this.players[newPlayerID].externalID = youtubeID;
          hasYouTube = true;
        } else if (newPlayerType === "video") {
          hasNative = true;
        }
      }

      if (hasNative) {
        if (window.isPlyrLoaded) {
          this.nativeInitCallback();
        } else {
          // Load Plyr
          window.loadPlyr();
          $("body").on("plyrReady", this.nativeInitCallback.bind(this));
        }
      }

      if (hasYouTube) {
        if (window.isYoutubeAPILoaded) {
          this.youTubeInitCallback();
        } else {
          // Load Youtube API
          window.loadYoutubeAPI();
          $("body").on("youtubeAPIReady", this.youTubeInitCallback.bind(this));
        }
      }
    },
    youTubeInitCallback: function () {
      var self = this;
      for (var currentPlayerID in this.players) {
        if (this.players[currentPlayerID].type === "external_video") {
          var currentPlayer = this.players[currentPlayerID],
            enableLooping =
              this.players[currentPlayerID].container.getAttribute(
                "data-video-looping"
              ) === "true";

          this.players[currentPlayerID].player = new YT.Player(
            currentPlayer.element,
            {
              videoId: currentPlayer.externalID,
              playerVars: {
                cc_load_policy: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                autohide: 0,
                controls: 1,
                branding: 0,
                showinfo: 0,
                rel: 0,
                fs: 0,
                wmode: "opaque",
              },
              events: {
                onStateChange: function (e) {
                  if (e.data === 0 && enableLooping) e.target.seekTo(0);
                  var currentMediaId = $(e.target.f)
                    .closest("[data-media-id]")
                    .attr("data-media-id");
                  if (e.data === 1) self.pauseOtherMedia(currentMediaId);
                  //console.log($(e.target.a).closest('[data-media-id]'));
                  //console.log($(e.target.f).closest('[data-media-id]'));
                  //console.log('statechange:', currentMediaId);
                },
              },
            }
          );

          $(this.players[currentPlayerID].container).on(
            "mediaHidden xrLaunch",
            function (event) {
              if (typeof event.target.dataset.playerId === "undefined") return;
              var newID = event.target.dataset.playerId;
              var sectionID = event.target.dataset.mediaKey;
              var newPlayer =
                window.theme.mediaInstances[sectionID].players[newID];
              if (newPlayer.player && newPlayer.player.pauseVideo) {
                newPlayer.player.pauseVideo();
                console.log("pause");
              }
            }
          );

          $(this.players[currentPlayerID].container).on(
            "mediaVisible",
            function (event) {
              //if (theme.TouchDetect.isTouch()) return;
              if (typeof event.target.dataset.playerId === "undefined") return;
              var newID = event.target.dataset.playerId;
              var sectionID = event.target.dataset.mediaKey;
              var newPlayer =
                window.theme.mediaInstances[sectionID].players[newID];
              if (newPlayer.player && newPlayer.player.playVideo) {
                newPlayer.player.playVideo();
                console.log("pkay");
              }
            }
          );
        }
      }
    },
    nativeInitCallback: function () {
      var self = this;
      for (var currentPlayerID in this.players) {
        if (this.players[currentPlayerID].type === "video") {
          var currentPlayer = this.players[currentPlayerID],
            enableLooping =
              this.players[currentPlayerID].container.getAttribute(
                "data-video-looping"
              ) === "true",
            plyrOptions = {
              loop: { active: true },
              focusOnPlay: true,
              autoplay: false,
              muted: true,
              playsinline: true,
              controls: [],
            };

          this.players[currentPlayerID].player = new Shopify.Plyr(
            currentPlayer.element,
            plyrOptions
          );
          this.players[currentPlayerID].player.on("play", function (event) {
            var currentMediaId = $(event.target)
              .closest("[data-media-id]")
              .attr("data-media-id");
            self.pauseOtherMedia(currentMediaId);

            console.log("nativeCB:", currentMediaId);
          });

          $(this.players[currentPlayerID].container).on(
            "mediaHidden xrLaunch",
            function (event) {
              if (typeof event.target.dataset.playerId === "undefined") return;
              var newID = event.target.dataset.playerId;
              var sectionID = event.target.dataset.mediaKey;
              var newPlayer =
                window.theme.mediaInstances[sectionID].players[newID];
              if (newPlayer.player && newPlayer.player.pause) {
                newPlayer.player.pause();
              }
            }
          );

          $(this.players[currentPlayerID].container).on(
            "mediaVisible",
            function (event) {
              //if (theme.TouchDetect.isTouch()) return;
              if (typeof event.target.dataset.playerId === "undefined") return;
              var newID = event.target.dataset.playerId;
              var sectionID = event.target.dataset.mediaKey;
              var newPlayer =
                window.theme.mediaInstances[sectionID].players[newID];
              console.log("pkay");
              if (newPlayer.player && newPlayer.player.play) {
                newPlayer.player.play();
              }
            }
          );
        }
      }
    },

    pauseOtherMedia: function (mediaId) {
      var $currentMedia = $(
          "[data-product-single-media-wrapper]" +
            '[data-media-id="' +
            mediaId +
            '"]'
        ),
        $otherMedia = $("[data-product-single-media-wrapper]").not(
          $currentMedia
        );

      $currentMedia.removeClass("media--hidden");
      $otherMedia.trigger("mediaHidden").addClass("media--hidden");
    },

    initZoom: function () {
      if ($(window).width() > 768  && !this.tallLayout) {
        $(selectors.zoomWrapper, this.$container).one("click", function () {
          var $this = $(this);
          $this.zoom({
            on: "click",
            touch: "false",
            callback: function () {
              $this.click();
            },
            onZoomIn: function () {
              $this.addClass("zoom--active");
            },
            onZoomOut: function () {
              $this.removeClass("zoom--active");
            },
          });
        });
      }
    },

    removeSectionVideos: function (sectionId) {
      for (var key in videos) {
        if (videos.hasOwnProperty(key)) {
          var video = videos[key];

          if (video.sectionId === sectionId) {
            if (video.player) video.player.destroy();
            delete videos[key];
          }
        }
      }

      delete theme.mediaInstances[sectionId];
    },

    onUnload: function () {
      this.$container.off(this.namespace);
      this.removeSectionVideos(this.id);
    },
  });

  return Media;
})();